<template>
  <div class="module-table">
    <el-table :data="moduleData" border size="small" class="data-table">
        <el-table-column label="序号" width="80">
          <template slot-scope="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column label="拍品名称">
            <template slot-scope="scope">
              {{ scope.row.auction_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="拍品所有人" min-width="180" >
            <template slot-scope="scope">
              {{ scope.row.auction_owner }}
            </template>
        </el-table-column>
        <el-table-column label="起拍价">
            <template slot-scope="scope">
              {{ scope.row.starting_price || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="法院名称">
            <template slot-scope="scope">
              {{ scope.row.court_name || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="成交结果">
            <template slot-scope="scope">
              {{ scope.row.deal_result || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="权证情况">
            <template slot-scope="scope">
              {{ scope.row.warrant_situation || '-' }}
            </template>
        </el-table-column>
        <el-table-column label="拍卖日期">
            <template slot-scope="scope">
              {{ scope.row.auction_date || '-' }}
            </template>
        </el-table-column>
        
    </el-table>
  </div>
</template>

<script>
export default {
    name: 'judicialAssistList',

    data() {
        return {
            title: '司法协助',
        }
    },  
    props: {
        moduleData: {
            type: Array,
            default: () => []
        }
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">
// 表格铺满
.module-table {
  width: 100%;
  .el-table { 
    width: 100%;
  }
}
</style>